import { useMemo } from 'react'
import { useLocation } from 'react-router'

import { Paths } from '../../config/routes'
import { useUser } from '../../contexts/user/user-context'
import { Card } from '../card'
import {
    ConnectedAccountsIcon,
    KYCIcon,
    NotificationsIcon,
    SecurityIcon,
    UnicornIcon,
} from './icons'
import { LogoutButton } from './logout-button'
import { MenuItem } from './menu-item'
export function SettingsMenu() {
    const location = useLocation()

    const { userProfile }: any = useUser()

    const [firstName, lastName, email] = useMemo(() => {
        if (userProfile && userProfile.getUserProfile) {
            return [
                userProfile.getUserProfile.firstName,
                userProfile.getUserProfile.lastName,
                userProfile.getUserProfile.email,
            ]
        } else {
            return ['', '']
        }
    }, [userProfile])

    return (
        <Card
            className='w-full h-full pt-8 flex flex-col overflow-scroll justify-between scrollbar-hide'
            style={{
                minWidth: 400,
                marginRight: 21,
            }}>
            <div>
                <h5 className='text-xl'>
                    {firstName} {lastName}
                </h5>
                <p className='m-0 text-sm font-light'>{email}</p>
                <div className='grid grid-rows-3 grid-cols-2 lg:grid-cols-1 overflow-scroll gap-4 pt-4 scrollbar-hide'>
                    <MenuItem
                        icon={<UnicornIcon />}
                        title='Personal information'
                        description='Name, email, phone number'
                        active={location.pathname.includes(
                            Paths.UPDATE_PROFILE,
                        )}
                        href={Paths.UPDATE_PROFILE}
                    />
                    <MenuItem
                        icon={<KYCIcon />}
                        title='KYC & identity'
                        href={Paths.UPDATE_SECURITY}
                        description='Manage your DeFi identity'
                    />
                    <MenuItem
                        icon={<SecurityIcon />}
                        title='Security & login'
                        description='Password & security settings'
                        href={Paths.UPDATE_SECURITY}
                        active={location.pathname.includes(
                            Paths.UPDATE_SECURITY,
                        )}
                    />
                    <MenuItem
                        icon={<ConnectedAccountsIcon />}
                        title='Connected accounts'
                        href={Paths.UPDATE_SECURITY}
                        description='Manage your connected accounts'
                    />
                    <MenuItem
                        icon={<NotificationsIcon />}
                        title='Notifications'
                        href={Paths.UPDATE_SECURITY}
                        description='Manage notification settings'
                    />
                </div>
            </div>
            <LogoutButton />
        </Card>
    )
}
